import { Component, Inject, Optional} from '@angular/core';
import { IContextService, PershingTranslationService, PershingError } from '@pershing/pershing-core';
import { Router, ActivatedRoute } from '@angular/router';
import { NxiConfigUtil } from '@pershing/nxi-common';
import { BehaviorSubject, Subscription } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'bmo-splash',
  templateUrl: './BMOSplash.component.html'
})
export class BMOSplashComponent {
  imageUrl: string;
  deviceType: string;
  community: string;
  isMobile: boolean = false;
  isTablet: boolean = false;
  data=[];
  content: any;
  themetype: string;
  siteName: string;
  language: string;
  offcode: string;
  private _error: BehaviorSubject<PershingError>;
  constructor(
    private translationService: PershingTranslationService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    @Optional() @Inject('AppSettings') appSettings: any,
    private router: Router,
    private contextService: IContextService
    ) { 
    this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    this.imageUrl = appSettings.ibdConfigMap.cdnURL + '/staticartifacts/@pershing/nxi-branding@'+appSettings.angularBrandVersion+'/assets/images/conservative/brands/bmodirectinvest/';
    this.deviceType = appSettings.deviceType;
    this.community = NxiConfigUtil.getCommunityName(appSettings);
    if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
      this.isMobile = true;
    }
    if (appSettings.deviceType && appSettings.deviceType === 'tablet') {
      this.isTablet = true;
    }
    this.siteName = appSettings.cmsSiteName;
    this.language = this.translate.currentLang;
    if (appSettings.ibdConfigMap) {
      this.themetype = appSettings.themeType;
    }
  }
   
  ngOnInit() {
    document.dispatchEvent(new CustomEvent('portal.browserTitleValue', {
        detail: {
          'titleValue': 'digital-advise-splash',
          'pageIdValue': 'digital-advise-splash'
        }
      }));
    this.retrieveContent();  
  }

  retrieveContent() {
    if (this.translationService) {
      this.translationService.get('BMOSPLASH.container3.content').subscribe( data=>{
        this.content = data;
        this.processContent();
      })
    }
  }

  navigateToMixinPage() {
    let pageName = '/nxi/digital-advise-mixin';
    let routeContext : any;
    if (this.contextService.getRouteContext instanceof Function) {
      routeContext = this.contextService.getRouteContext();
      routeContext = this.convertRouteContextStringToObj(routeContext);
    }
    if (!!routeContext && routeContext.offcode == 'T9H') {
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
          detail: {
            'gotoParams': this.contextService.getRouteContext(),
            'gotoPage': pageName
          }
        }));
    } else {
      window.location.href = pageName;
    }
  }

  convertRouteContextStringToObj(routeContext) {
    if (!!routeContext && typeof routeContext === 'string') {
      const result = {};
      routeContext = new URLSearchParams(routeContext);
      for (const [key, value] of routeContext) {
        result[key] = value;
      }
      routeContext = result;
    }
    return routeContext;
  }

  goToPage(page: string, params: any) {
    document.dispatchEvent(new CustomEvent('portal.gotoview', {
      detail: {
        'gotoPage': page,
        'gotoParams': params ? params : {}
      }
    }));
  }

  navigateToAccountNAOPage(){
    window.location.href = '/nxi/account-status-nao';
  }

  processContent() {
    var QIndex = this.getIndices("Q:");
    var AIndex = this.getIndices("</a>");
    var AnsIndex = this.getIndices("A:");
    var DivIndex = this.getIndices("</div>");
    this.data = [];
    for (var i = 0; i < QIndex.length; i++) {
        this.data.push({
            question: this.content.substring(QIndex[i] + 2, AIndex[i]),
            answer: this.content.substring(AnsIndex[i] + 2, DivIndex[i]).replace("<br>", "").replace("&nbsp;", ""),
            display: false
        });
    }
}

getIndices(searchKeyword) {
  var str = this.content;
  var startingIndices = [];
  var indexOccurence = str.indexOf(searchKeyword, 0);
  while (indexOccurence >= 0) {
      startingIndices.push(indexOccurence);
      indexOccurence = str.indexOf(searchKeyword, indexOccurence + 1);
  }
  return startingIndices;
}

setError(errorMessage: string, errorCode?: string): void {
  this._error.next(new PershingError(errorMessage, 'BMOSplashComponent', errorCode));
}

}
